import API_BASE_URL from '../config/apiBaseUrl';

const maintenanceService = {
  getStatus: async () => {
    const response = await fetch(`${API_BASE_URL}/maintenance/status`, {
      headers: { Accept: 'application/json' }
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data?.message || 'Impossible de vérifier le mode maintenance.');
    }

    return data;
  }
};

export default maintenanceService;
